import * as React from 'react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import styled from '@emotion/styled/macro'

import { Icon } from '~/components/atoms/Icon'
import { OutlineButton } from '~/components/atoms/OutlineButton'

export interface CartButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label?: ReactNode
}

export function CartButton({
  label = 'カートに入れる',
  ...rest
}: CartButtonProps) {
  return (
    <StyledOutlineButton colorTheme="red" fullWidth {...rest}>
      <ButtonBody>
        <ButtonIcon>
          <Icon type="cart-in" />
        </ButtonIcon>
        <ButtonLabel>{label}</ButtonLabel>
      </ButtonBody>
    </StyledOutlineButton>
  )
}

const StyledOutlineButton = styled(OutlineButton)`
  --_shadow-cast: 4px 4px 8px hsla(0, 0%, 25%, 0.3);
  box-shadow: var(--_shadow-cast);

  &:hover:not(:disabled):not([aria-disabled='true']) {
    box-shadow: var(--_shadow-cast);
  }
`

const ButtonBody = styled.span`
  display: inline-flex;
  gap: var(--gutter-small);
  align-items: center;
`

const ButtonIcon = styled.span`
  display: inline-grid;
  place-items: center;
  font-size: 24px;
`

const ButtonLabel = styled.span`
  letter-spacing: 0.1em;
  font-size: 12px;
  line-height: 2;

  user-select: none;
  white-space: nowrap;
`
